import { Component, OnInit, Input } from '@angular/core';
import { MbIconModule, MbExpandablePanelModule } from '@am/moebius';
import { SeoDetailComponent } from '../seo-detail/seo-detail.component';
import { NgIf, NgFor } from '@angular/common';
import { CardInfoDetailV2Component } from '@commons/card-info-detail-v2/card-info-detail-v2.component';

@Component({
    selector: 'description',
    templateUrl: './description.component.html',
    styleUrls: ['./description.component.scss'],
    standalone: true,
    imports: [
        CardInfoDetailV2Component,
        NgIf,
        SeoDetailComponent,
        NgFor,
        MbIconModule,
        MbExpandablePanelModule,
    ],
})
export class DescriptionComponent implements OnInit {
  @Input() description: any;
  @Input() additionalInfos: any[];
  @Input() hotelStatic: any;
  @Input() isLanding: boolean;

  arrayDescription: any[] = [];
  arrayMoreDescription: any[] = [];
  arrayLessDescription: any[] = [];

  textUrl = '';
  textResult: any[] = [];

  ngOnInit() {
    const parrafo = /([.]+[\s])/;
    const description = this.description.hotel_description.concat(' ');
    this.arrayDescription = description.split(parrafo);

    this.arrayDescription.filter((value, index, arr) => {
      if (value === '.\n' || value === '. ' || value === ' ') {
        arr.splice(index, 1);
        return true;
      }
      return false;
    });

    this.previewDescription();
  }

  splitText(parrafo: string) {
    return parrafo.split(' ');
  }

  validRegExp(parrafo: string) {
    const url = new RegExp(/([htp:/w]+[.]+([\w]*)+[.]+[com]{3})/);
    if (url.test(parrafo)) {
      this.textResult = this.splitText(parrafo);
    }
    return url.test(parrafo);
  }

  onClickViewMoreLess(viewLess) {
    this.arrayDescription = viewLess
      ? this.arrayLessDescription
      : this.arrayMoreDescription;
  }

  previewDescription() {
    // TODO: si hay poco texo en el pirmer elemento poner mas
    let characters = 0;
    let i = 0;
    while (characters < 100) {
      characters = characters + this.arrayDescription[i].length;
      this.arrayLessDescription.push(this.arrayDescription[i]);
      i++;
    }

    this.arrayMoreDescription = this.arrayDescription;

    this.onClickViewMoreLess(true);
  }
}
